/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'components';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { SOFTWARE_PACKAGE_STATUS_COLORS } from 'common/constants';
import { colors } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  label: {
    marginRight: theme.spacing(1)
  },
  link: {
    cursor: 'pointer'
  }
}));

const MonitoredSoftwareVersions = props => {
  const classes = useStyles();

  const { softwareVersions } = props;

  const PACKAGES = {
    'xonar-cell-credentials': { label: 'Credentials' },
    'xonar-mqtt-tls': { label: 'MQTT TLS' },
    'xonar-cell-os-apt': { label: 'Host', display: false },
    'xonar-cell-software': { label: 'Cell Software' },
    'xonar-cell-software-docker': { label: 'Docker', display: true },
    'truescan-pxray': { label: 'PXray', display: true },
    'xonar-cell-software-edge-agent': { label: 'Edge', display: false },
    'xonar-cell-software-lcd-ui': { label: 'LCD', display: false },
    'xonar-operator-middleware': { label: 'Middleware' },
    'xonar-api-credentials': { label: 'Credentials' },
    'xonar-trueport-device-software': {
      label: 'Device Software',
      display: true
    },
    'xonar-trueport-device-setup': { label: 'Device Setup', display: false },
    'balena-release': {
      label: null,
      display: true,
      preserveVersionDetail: true
    }
  };

  const filteredSoftwareVersions = softwareVersions
    ? softwareVersions.filter(s => PACKAGES[s.name]?.display)
    : [];

  filteredSoftwareVersions.sort((a, b) =>
    b.version
      .toLowerCase()
      .localeCompare(a.version.toLowerCase(), 'en', { numeric: true })
  );

  const Version = props => {
    const { softwareVersion } = props;
    const preserveVersionDetail =
      PACKAGES[softwareVersion.name]?.preserveVersionDetail;

    console.log('softwareVersion', PACKAGES[softwareVersion.name]);

    const versionNumber = preserveVersionDetail
      ? softwareVersion.version
      : softwareVersion.softwarePackage?.status !== 'GENERAL_RELEASE'
      ? softwareVersion.versionLessCommitHash
      : softwareVersion.versionLessCommitHash.substring(
          0,
          softwareVersion.versionLessCommitHash.lastIndexOf('.')
        );

    return (
      <Label
        key={softwareVersion.name}
        color={
          SOFTWARE_PACKAGE_STATUS_COLORS[
            softwareVersion.softwarePackage?.status
          ] || colors.blueGrey[500]
        }
        className={clsx(
          classes.label,
          softwareVersion.softwarePackage?.id || softwareVersion.balenaReleaseId
            ? classes.link
            : ''
        )}
        onClick={() =>
          softwareVersion.balenaReleaseId
            ? window.open(
                `https://dashboard.balena-cloud.com/fleets/2316773/releases/${softwareVersion.balenaReleaseId}/summary`,
                '_blank'
              )
            : softwareVersion.softwarePackage?.id
            ? (window.location = `/software/packages/${softwareVersion.softwarePackage?.id}/summary`)
            : null
        }>
        {versionNumber}
      </Label>
    );
  };

  return (
    <>
      {filteredSoftwareVersions.length > 0 && (
        <Version softwareVersion={filteredSoftwareVersions[0]} />
      )}
    </>
  );
};

MonitoredSoftwareVersions.propTypes = {
  softwareVersions: PropTypes.array
};

export default MonitoredSoftwareVersions;
